import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enCommon from './locales/en/common.json';
import esCommon from './locales/es/common.json';
import ptCommon from './locales/pt/common.json';
import enDynamic from './locales/en/dynamic.json';
import esDynamic from './locales/es/dynamic.json';
import ptDynamic from './locales/pt/dynamic.json';

// Same key useAppLanguage persists the selection under.
const STORAGE_KEY = 'language';
export const SUPPORTED_LANGUAGES = ['en', 'es', 'pt'] as const;

const readSavedLanguage = (): string => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && (SUPPORTED_LANGUAGES as readonly string[]).includes(saved)) return saved;
  } catch {
    // storage unavailable
  }
  // First launch: follow the device language when we support it.
  const device = (navigator.language || 'en').slice(0, 2);
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(device) ? device : 'en';
};

i18n.use(initReactI18next).init({
  resources: {
    en: { common: enCommon, dynamic: enDynamic },
    es: { common: esCommon, dynamic: esDynamic },
    pt: { common: ptCommon, dynamic: ptDynamic },
  },
  lng: readSavedLanguage(),
  fallbackLng: 'en',
  defaultNS: 'common',
  interpolation: { escapeValue: false }, // React already escapes
});

document.documentElement.lang = i18n.language;

export default i18n;
